module.exports = __webpack_public_path__ + "14ffff338b251def214d188fb2b84a21.png";